function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module media-embed/ui/mediaformview
 */
import { ButtonView, FocusCycler, LabeledFieldView, View, ViewCollection, createLabeledInputText, injectCssTransitionDisabler, submitHandler } from 'ckeditor5/src/ui';
import { FocusTracker, KeystrokeHandler } from 'ckeditor5/src/utils';
import { icons } from 'ckeditor5/src/core'; // See: #8833.
// eslint-disable-next-line ckeditor5-rules/ckeditor-imports

import '@ckeditor/ckeditor5-ui/theme/components/responsive-form/responsiveform.css';
import '../../theme/mediaform.css';
/**
 * The media form view controller class.
 *
 * See {@link module:media-embed/ui/mediaformview~MediaFormView}.
 *
 * @extends module:ui/view~View
 */

var MediaFormView = /*#__PURE__*/function (_View) {
  _inherits(MediaFormView, _View);

  var _super = _createSuper(MediaFormView);

  /**
   * @param {Array.<Function>} validators Form validators used by {@link #isValid}.
   * @param {module:utils/locale~Locale} [locale] The localization services instance.
   */
  function MediaFormView(validators, locale) {
    var _this;

    _classCallCheck(this, MediaFormView);

    _this = _super.call(this, locale);
    var t = locale.t;
    /**
     * Tracks information about the DOM focus in the form.
     *
     * @readonly
     * @member {module:utils/focustracker~FocusTracker}
     */

    _this.focusTracker = new FocusTracker();
    /**
     * An instance of the {@link module:utils/keystrokehandler~KeystrokeHandler}.
     *
     * @readonly
     * @member {module:utils/keystrokehandler~KeystrokeHandler}
     */

    _this.keystrokes = new KeystrokeHandler();
    /**
     * The value of the URL input.
     *
     * @member {String} #mediaURLInputValue
     * @observable
     */

    _this.set('mediaURLInputValue', '');
    /**
     * The URL input view.
     *
     * @member {module:ui/labeledfield/labeledfieldview~LabeledFieldView}
     */


    _this.urlInputView = _this._createUrlInput();
    /**
     * The Save button view.
     *
     * @member {module:ui/button/buttonview~ButtonView}
     */

    _this.saveButtonView = _this._createButton(t('Save'), icons.check, 'ck-button-save');
    _this.saveButtonView.type = 'submit';

    _this.saveButtonView.bind('isEnabled').to(_assertThisInitialized(_this), 'mediaURLInputValue', function (value) {
      return !!value;
    });
    /**
     * The Cancel button view.
     *
     * @member {module:ui/button/buttonview~ButtonView}
     */


    _this.cancelButtonView = _this._createButton(t('Cancel'), icons.cancel, 'ck-button-cancel', 'cancel');
    /**
     * A collection of views that can be focused in the form.
     *
     * @readonly
     * @protected
     * @member {module:ui/viewcollection~ViewCollection}
     */

    _this._focusables = new ViewCollection();
    /**
     * Helps cycling over {@link #_focusables} in the form.
     *
     * @readonly
     * @protected
     * @member {module:ui/focuscycler~FocusCycler}
     */

    _this._focusCycler = new FocusCycler({
      focusables: _this._focusables,
      focusTracker: _this.focusTracker,
      keystrokeHandler: _this.keystrokes,
      actions: {
        // Navigate form fields backwards using the <kbd>Shift</kbd> + <kbd>Tab</kbd> keystroke.
        focusPrevious: 'shift + tab',
        // Navigate form fields forwards using the <kbd>Tab</kbd> key.
        focusNext: 'tab'
      }
    });
    /**
     * An array of form validators used by {@link #isValid}.
     *
     * @readonly
     * @protected
     * @member {Array.<Function>}
     */

    _this._validators = validators;

    _this.setTemplate({
      tag: 'form',
      attributes: {
        class: ['ck', 'ck-media-form', 'ck-responsive-form'],
        tabindex: '-1'
      },
      children: [_this.urlInputView, _this.saveButtonView, _this.cancelButtonView]
    });

    injectCssTransitionDisabler(_assertThisInitialized(_this));
    /**
     * The default info text for the {@link #urlInputView}.
     *
     * @private
     * @member {String} #_urlInputViewInfoDefault
     */

    /**
     * The info text with an additional tip for the {@link #urlInputView},
     * displayed when the input has some value.
     *
     * @private
     * @member {String} #_urlInputViewInfoTip
     */

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(MediaFormView, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      _get(_getPrototypeOf(MediaFormView.prototype), "render", this).call(this);

      submitHandler({
        view: this
      });
      var childViews = [this.urlInputView, this.saveButtonView, this.cancelButtonView];
      childViews.forEach(function (v) {
        // Register the view as focusable.
        _this2._focusables.add(v); // Register the view in the focus tracker.


        _this2.focusTracker.add(v.element);
      }); // Start listening for the keystrokes coming from #element.

      this.keystrokes.listenTo(this.element);

      var stopPropagation = function stopPropagation(data) {
        return data.stopPropagation();
      }; // Since the form is in the dropdown panel which is a child of the toolbar, the toolbar's
      // keystroke handler would take over the key management in the URL input. We need to prevent
      // this ASAP. Otherwise, the basic caret movement using the arrow keys will be impossible.


      this.keystrokes.set('arrowright', stopPropagation);
      this.keystrokes.set('arrowleft', stopPropagation);
      this.keystrokes.set('arrowup', stopPropagation);
      this.keystrokes.set('arrowdown', stopPropagation); // Intercept the `selectstart` event, which is blocked by default because of the default behavior
      // of the DropdownView#panelView.
      // TODO: blocking `selectstart` in the #panelView should be configurable per–drop–down instance.

      this.listenTo(this.urlInputView.element, 'selectstart', function (evt, domEvt) {
        domEvt.stopPropagation();
      }, {
        priority: 'high'
      });
    }
    /**
     * Focuses the fist {@link #_focusables} in the form.
     */

  }, {
    key: "focus",
    value: function focus() {
      this._focusCycler.focusFirst();
    }
    /**
     * The native DOM `value` of the {@link #urlInputView} element.
     *
     * **Note**: Do not confuse it with the {@link module:ui/inputtext/inputtextview~InputTextView#value}
     * which works one way only and may not represent the actual state of the component in the DOM.
     *
     * @type {String}
     */

  }, {
    key: "url",
    get: function get() {
      return this.urlInputView.fieldView.element.value.trim();
    },
    set: function set(url) {
      this.urlInputView.fieldView.element.value = url.trim();
    }
    /**
     * Validates the form and returns `false` when some fields are invalid.
     *
     * @returns {Boolean}
     */

  }, {
    key: "isValid",
    value: function isValid() {
      this.resetFormStatus();

      var _iterator = _createForOfIteratorHelper(this._validators),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var validator = _step.value;
          var errorText = validator(this); // One error per field is enough.

          if (errorText) {
            // Apply updated error.
            this.urlInputView.errorText = errorText;
            return false;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return true;
    }
    /**
     * Cleans up the supplementary error and information text of the {@link #urlInputView}
     * bringing them back to the state when the form has been displayed for the first time.
     *
     * See {@link #isValid}.
     */

  }, {
    key: "resetFormStatus",
    value: function resetFormStatus() {
      this.urlInputView.errorText = null;
      this.urlInputView.infoText = this._urlInputViewInfoDefault;
    }
    /**
     * Creates a labeled input view.
     *
     * @private
     * @returns {module:ui/labeledfield/labeledfieldview~LabeledFieldView} Labeled input view instance.
     */

  }, {
    key: "_createUrlInput",
    value: function _createUrlInput() {
      var _this3 = this;

      var t = this.locale.t;
      var labeledInput = new LabeledFieldView(this.locale, createLabeledInputText);
      var inputField = labeledInput.fieldView;
      this._urlInputViewInfoDefault = t('Paste the media URL in the input.');
      this._urlInputViewInfoTip = t('Tip: Paste the URL into the content to embed faster.');
      labeledInput.label = t('Media URL');
      labeledInput.infoText = this._urlInputViewInfoDefault;
      inputField.on('input', function () {
        // Display the tip text only when there is some value. Otherwise fall back to the default info text.
        labeledInput.infoText = inputField.element.value ? _this3._urlInputViewInfoTip : _this3._urlInputViewInfoDefault;
        _this3.mediaURLInputValue = inputField.element.value.trim();
      });
      return labeledInput;
    }
    /**
     * Creates a button view.
     *
     * @private
     * @param {String} label The button label.
     * @param {String} icon The button icon.
     * @param {String} className The additional button CSS class name.
     * @param {String} [eventName] An event name that the `ButtonView#execute` event will be delegated to.
     * @returns {module:ui/button/buttonview~ButtonView} The button view instance.
     */

  }, {
    key: "_createButton",
    value: function _createButton(label, icon, className, eventName) {
      var button = new ButtonView(this.locale);
      button.set({
        label: label,
        icon: icon,
        tooltip: true
      });
      button.extendTemplate({
        attributes: {
          class: className
        }
      });

      if (eventName) {
        button.delegate('execute').to(this, eventName);
      }

      return button;
    }
  }]);

  return MediaFormView;
}(View);
/**
 * Fired when the form view is submitted (when one of the children triggered the submit event),
 * e.g. click on {@link #saveButtonView}.
 *
 * @event submit
 */

/**
 * Fired when the form view is canceled, e.g. by a click on {@link #cancelButtonView}.
 *
 * @event cancel
 */


export { MediaFormView as default };